// ============================================================================
// TRADITIONAL CHINESE TRANSLATIONS - CHAPTER 5: 初代教會
// ============================================================================
// 級別 53-65 (13個級別，39個問題)

export const chapter5Translations = {
  name: "初代教會",
  description: "你們要得著能力...",
  
  spiritualWisdom: {
    principle: "聖靈賜下見證的能力和勇氣",
    scripture: "聖靈降臨在你們身上，你們就必得著能力，並要作我的見證 (使徒行傳 1:8)",
    application: "教會在聖靈的火中誕生，因勇敢的見證而成長"
  },
  
  levels: {
    53: {
      name: "升天",
      challenge: "你們要作我的見證...直到地極...",
      easy: {
        question: "耶穌在復活後多少天升天？",
        options: ["30天", "40天", "50天", "60天"],
        hint: "預備的聖經數字",
        funFact: "☁️ 世界宣教前40天的密集教導！"
      },
      medium: {
        question: "耶穌升天前作了什麼應許？",
        options: [
          "立刻回來",
          "帶著能力差遣聖靈",
          "建立教會",
          "懲罰惡人"
        ],
        hint: "從上頭來的能力",
        funFact: "⚡ 聖靈的應許 - 懼怕的門徒的轉變！"
      },
      hard: {
        question: "升天在我們的屬靈生命中象徵什麼？",
        options: [
          "耶穌同在的結束",
          "耶穌在天上掌權並為我們代求",
          "最後的告別",
          "象徵性神話"
        ],
        hint: "關乎榮耀中活著的同在",
        funFact: "👑 耶穌坐在神的右邊掌權並為我們代求！"
      }
    },
    
    54: {
      name: "五旬節",
      challenge: "他們都被聖靈充滿，就說起話來...",
      easy: {
        question: "升天後多少天發生了五旬節？",
        options: ["7天", "10天", "14天", "20天"],
        hint: "大約十天",
        funFact: "🔟 10天熱切禱告預備聖靈的澆灌！"
      },
      medium: {
        question: "聖靈以什麼形式顯現？",
        options: [
          "如同大風颳過",
          "如同舌頭分開，形狀像火",
          "如同鴿子",
          "如同光"
        ],
        hint: "停在每個門徒身上的火焰",
        funFact: "🔥 火焰般的舌頭：聖靈賜下勇氣和方言的恩賜！"
      },
      hard: {
        question: "五旬節對普世教會代表什麼？",
        options: [
          "孤立的歷史事件",
          "宣教教會的正式誕生",
          "好奇的神蹟",
          "節期的開始"
        ],
        hint: "關乎教會的出生證明",
        funFact: "🎂 五旬節 = 教會的生日，世界宣教的開始！"
      }
    },

    55: {
      name: "彼得的第一次講道",
      challenge: "我們當怎樣行，弟兄們？你們要悔改...",
      easy: {
        question: "彼得講道後有多少人受洗？",
        options: ["1000人", "2000人", "3000人", "5000人"],
        hint: "三千靈魂",
        funFact: "🌊 一天3000人受洗 - 非凡的屬靈覺醒！"
      },
      medium: {
        question: "彼得指責眾人什麼罪？",
        options: [
          "無知",
          "把彌賽亞耶穌釘在十字架上",
          "缺乏信心",
          "假冒為善"
        ],
        hint: "對神兒子的至高罪行",
        funFact: "⚔️ 曾經否認耶穌的彼得，現在宣告祂的神性！"
      },
      hard: {
        question: "彼得的改變如何顯明聖靈的工作？",
        options: [
          "變得更有教養",
          "從膽怯不穩到勇敢信心堅固",
          "獲得權力",
          "性格改變"
        ],
        hint: "關乎聖靈的成聖",
        funFact: "🗿 '搖動的蘆葦'變成'堅固的磐石' - 轉變的大能！"
      }
    },

    56: {
      name: "最初的團契",
      challenge: "他們恆心遵守使徒的教訓，彼此交接...",
      easy: {
        question: "最初的基督徒如何分享財物？",
        options: [
          "各人保留自己的",
          "分享一切",
          "只有富人給予",
          "通過法律義務"
        ],
        hint: "自願分享財物",
        funFact: "🤝 弟兄之愛如此強烈，以至於自願分享一切！"
      },
      medium: {
        question: "最初的基督徒把時間花在什麼上？",
        options: [
          "只做生意",
          "教導、團契、擘餅、禱告",
          "只工作",
          "休閒"
        ],
        hint: "團契生活的四大支柱",
        funFact: "⛪ 教導、團契、聖餐、禱告 - 教會的根基！"
      },
      hard: {
        question: "為什麼這個最初的團契如此吸引人？",
        options: [
          "他們很富有",
          "真誠的愛和喜樂從他們的合一中散發",
          "他們應許神蹟",
          "他們批評別人"
        ],
        hint: "關乎愛的活見證",
        funFact: "✨ '看哪，他們彼此相愛！' - 比言語更有說服力的見證！"
      }
    },

    57: {
      name: "瘸子得醫治",
      challenge: "金銀我都沒有，只把我所有的給你...",
      easy: {
        question: "這個人瘸腿多久了？",
        options: [
          "20年",
          "30年", 
          "生來就瘸腿",
          "10年"
        ],
        hint: "生來就殘疾",
        funFact: "🚶 40年的殘疾因耶穌的名立刻得醫治！"
      },
      medium: {
        question: "彼得奉誰的名醫治瘸子？",
        options: [
          "奉神的名",
          "奉拿撒勒人耶穌基督的名",
          "奉自己的名",
          "奉亞伯拉罕的名"
        ],
        hint: "超乎萬名之上的名",
        funFact: "✊ 耶穌的名繼續透過使徒行神蹟！"
      },
      hard: {
        question: "這次醫治對福音象徵什麼？",
        options: [
          "簡單的醫學奇蹟",
          "耶穌帶來的完全救恩：屬靈和身體的",
          "使徒的能力",
          "對窮人的慈善"
        ],
        hint: "關乎人的全然救贖",
        funFact: "🩺 耶穌醫治靈魂和身體 - 人的完全救恩！"
      }
    },

    58: {
      name: "逼迫開始",
      challenge: "順從神，不順從人，是應當的...",
      easy: {
        question: "瘸子得醫治後，誰逮捕了彼得和約翰？",
        options: [
          "羅馬人",
          "撒都該人和祭司",
          "百姓",
          "彼拉多"
        ],
        hint: "猶太宗教當局",
        funFact: "⛓️ 第一次宗教逼迫 - 福音攪動既得利益！"
      },
      medium: {
        question: "當局禁止使徒做什麼？",
        options: [
          "離開耶路撒冷",
          "不可再奉耶穌的名教訓人",
          "不可再行神蹟",
          "不可再禱告"
        ],
        hint: "禁止傳道",
        funFact: "🚫 試圖使真理沉默 - 不可能阻止福音！"
      },
      hard: {
        question: "使徒如何回應這個禁令？",
        options: [
          "害怕並順從",
          "宣告順從神不順從人是應當的",
          "談判",
          "逃跑"
        ],
        hint: "關乎高於人類法律的忠誠",
        funFact: "⚖️ 為順從神而公民不服從 - 信念的勇氣！"
      }
    },

    59: {
      name: "亞拿尼亞和撒非喇",
      challenge: "你不是欺哄人，是欺哄神了...",
      easy: {
        question: "亞拿尼亞和撒非喇說了什麼謊言？",
        options: [
          "他們什麼都沒賣",
          "私自留下一部分卻說獻上全部",
          "他們很窮",
          "他們沒結婚"
        ],
        hint: "關於奉獻金額的謊言",
        funFact: "💰 留下一部分是可以的，但對奉獻說謊不行！"
      },
      medium: {
        question: "說謊後他們發生了什麼？",
        options: [
          "被赦免",
          "立刻死了",
          "被驅逐",
          "悔改了"
        ],
        hint: "立即的嚴厲懲罰",
        funFact: "⚱️ 嚴厲的審判，為保守初生教會的純潔！"
      },
      hard: {
        question: "為什麼在教會初期有如此嚴厲的懲罰？",
        options: [
          "神很殘忍",
          "為建立對團契要求的聖潔",
          "為嚇唬人",
          "偶然"
        ],
        hint: "關乎保持屬靈誠信",
        funFact: "🔥 起初設立高標準，以建立聖潔的文化！"
      }
    },

    60: {
      name: "七個執事",
      challenge: "當從你們中間選出七個有好名聲的人...",
      easy: {
        question: "選了多少個執事？",
        options: ["5個", "6個", "7個", "12個"],
        hint: "完全的數字",
        funFact: "7️⃣ 七個執事服事 - 教會的神聖組織！"
      },
      medium: {
        question: "他們的主要職責是什麼？",
        options: [
          "傳福音",
          "管理飯食，幫助寡婦",
          "給新信徒施洗",
          "管理財務"
        ],
        hint: "社會和物質服事",
        funFact: "🍽️ 管理飯食 = 第一個基督教慈善組織！"
      },
      hard: {
        question: "這個組織揭示了關於服事的基督教觀念是什麼？",
        options: [
          "物質工作低人一等",
          "屬靈服事和物質服事同樣神聖",
          "必須分開聖與俗",
          "只有祭司真正服事"
        ],
        hint: "關乎一切愛的服事的神聖性",
        funFact: "✨ 管理飯食與講道同樣尊貴 - 一切服事都是神聖的！"
      }
    },

    61: {
      name: "司提反，第一位殉道者",
      challenge: "主啊，不要將這罪歸於他們！說了這話，就睡了...",
      easy: {
        question: "司提反在教會中的角色是什麼？",
        options: ["使徒", "執事", "祭司", "先知"],
        hint: "被選服事的七人之一",
        funFact: "✨ 司提反：執事成為大有能力的傳福音者和第一位殉道者！"
      },
      medium: {
        question: "司提反指責猶太領袖什麼？",
        options: [
          "腐敗",
          "時常抗拒聖靈",
          "假冒為善",
          "貪婪"
        ],
        hint: "對神的歷史性抵抗",
        funFact: "📜 司提反總結歷史：對神不斷的悖逆！"
      },
      hard: {
        question: "司提反如何死去，他的態度揭示了什麼？",
        options: [
          "對行刑者憤怒",
          "像十字架上的耶穌一樣饒恕",
          "絕望中",
          "咒詛仇敵"
        ],
        hint: "關乎對基督的完美效法",
        funFact: "💝 饒恕行刑者：司提反完美再現耶穌的態度！"
      }
    },

    62: {
      name: "腓利和衣索匹亞太監",
      challenge: "沒有人指教我，怎能明白呢？",
      easy: {
        question: "太監在車上讀什麼？",
        options: [
          "詩篇",
          "先知以賽亞書",
          "創世記",
          "箴言"
        ],
        hint: "預言彌賽亞受難的先知",
        funFact: "📖 以賽亞書53章 - 真誠尋求者所讀的關於耶穌的完美預言！"
      },
      medium: {
        question: "腓利如何解釋以賽亞的經文？",
        options: [
          "講述古代歷史",
          "從這經文起，向他傳講耶穌",
          "進行神學講座",
          "批評解釋"
        ],
        hint: "聖經自然引向基督",
        funFact: "✝️ 所有聖經都匯聚於耶穌 - 理解的鑰匙！"
      },
      hard: {
        question: "衣索匹亞太監的歸信象徵什麼？",
        options: [
          "孤立的歸信",
          "福音對所有種族和身份的普世性",
          "某個民族的優越性",
          "特殊案例"
        ],
        hint: "關乎向萬國開放",
        funFact: "🌍 衣索匹亞人、太監、大臣：福音打破一切障礙！"
      }
    },

    63: {
      name: "大數的掃羅歸主",
      challenge: "掃羅，掃羅，你為什麼逼迫我？",
      easy: {
        question: "掃羅歸主前在做什麼？",
        options: [
          "傳福音",
          "逼迫基督徒",
          "中立",
          "只學習"
        ],
        hint: "門徒的激烈仇敵",
        funFact: "⚔️ 掃羅仍然向主的門徒口吐威嚇凶殺的話！"
      },
      medium: {
        question: "耶穌在哪條路上向掃羅顯現？",
        options: [
          "去耶路撒冷的路",
          "去大馬士革的路",
          "去加薩的路",
          "去安提阿的路"
        ],
        hint: "敘利亞的城市",
        funFact: "🛤️ 大馬士革路 = 歷史上最著名的轉變地點！"
      },
      hard: {
        question: "這次歸信如何顯明神的恩典？",
        options: [
          "神只讓好人歸信",
          "恩典能把最壞的仇敵變成最偉大的使徒",
          "歸信是應得的",
          "掃羅已經接近神"
        ],
        hint: "關乎恩典改變的大能",
        funFact: "⚡ 從最大的逼迫者到最大的宣教士 - 恩典的神蹟！"
      }
    },

    64: {
      name: "彼得和哥尼流",
      challenge: "我真看出神是不偏待人的...",
      easy: {
        question: "哥尼流的職業是什麼？",
        options: [
          "商人",
          "羅馬百夫長",
          "祭司",
          "文士"
        ],
        hint: "羅馬軍隊的軍官",
        funFact: "🎖️ 第一個正式歸信的外邦人 - 向非猶太人開放！"
      },
      medium: {
        question: "彼得在見哥尼流之前看到什麼異象？",
        options: [
          "天使說話",
          "一塊布，上面有潔淨和不潔淨的動物",
          "耶穌顯現",
          "聖殿被毀"
        ],
        hint: "關於潔淨與不潔淨的異象",
        funFact: "🕊️ 裝著動物的布：神廢除食物和種族的區別！"
      },
      hard: {
        question: "這次歸信確立了什麼革命性原則？",
        options: [
          "羅馬人優越",
          "神不偏待人 - 普世救恩",
          "必須放棄傳統",
          "割禮無用"
        ],
        hint: "關乎救恩的普世性",
        funFact: "🌍 屬靈革命：福音是給所有民族的，無一例外！"
      }
    },

    65: {
      name: "安提阿教會",
      challenge: "門徒稱為基督徒是從安提阿起首...",
      easy: {
        question: "門徒在安提阿第一次被稱為什麼？",
        options: ["門徒", "基督徒", "信徒", "聖徒"],
        hint: "我們至今使用的名字",
        funFact: "✝️ '基督徒' = '小基督' - 外邦人給的榮譽之名！"
      },
      medium: {
        question: "誰和巴拿巴一起來安提阿教導？",
        options: [
          "彼得",
          "保羅（掃羅）",
          "雅各",
          "約翰"
        ],
        hint: "從前的逼迫者成為使徒",
        funFact: "👥 巴拿巴去大數找保羅 - 保羅事工的開始！"
      },
      hard: {
        question: "為什麼安提阿在基督教歷史中變得如此重要？",
        options: [
          "很富有",
          "向外邦人宣教的第一個中心",
          "地理位置好",
          "有好領袖"
        ],
        hint: "關乎宣教擴展",
        funFact: "🚢 安提阿：保羅所有歐洲宣教旅程的出發港！"
      }
    }
  }
};

export default chapter5Translations;
